import { Chip, styled } from '@mui/material';
import { CommonEntityState } from '../../../data/models/entity-state';
import { capitalize } from 'lodash';

interface CommonEntityStateChipProps {
  state: CommonEntityState;
}

const BaseChip = styled(Chip)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  height: '36px',
  borderRadius: '64px',
  '& .MuiChip-label': {
    fontWeight: '600 !important',
    fontSize: '12px !important',
    letterSpacing: '.14px !important',
    lineHeight: '12px !important',
    padding: '0 !important',
    display: 'inline-block',
    textAlign: 'center',
  },
}));

const ActiveChip = styled(BaseChip)(({ theme }) => ({
  backgroundColor: theme.palette.statusBackground.main,
  '& .MuiChip-label': {
    color: `${theme.palette.statusActive.main} !important`,
    width: 33,
  },
}));

const InactiveOrDraftChip = styled(BaseChip)(({ theme }) => ({
  backgroundColor: theme.palette.lightActionDisabled08p.main,
  '& .MuiChip-label': {
    color: `${theme.palette.lightSecondaryPrimarySubtle.main} !important`,
  },
}));

const InactiveChip = styled(InactiveOrDraftChip)(({ theme }) => ({
  '& .MuiChip-label': {
    width: 43,
  },
}));

const DraftChip = styled(InactiveOrDraftChip)(({ theme }) => ({
  '& .MuiChip-label': {
    width: 27,
  },
}));

export default function CommonEntityStateChip({
  state,
}: CommonEntityStateChipProps) {
  switch (state) {
    case CommonEntityState.Active:
      return <ActiveChip label={capitalize(state)} />;
    case CommonEntityState.Draft:
      return <DraftChip label={capitalize(state)} />;
    case CommonEntityState.Inactive:
      return <InactiveChip label={capitalize(state)} />;
  }
  return <></>;
}
